<script lang="ts">
  interface Props {
    rows?: number;
    height?: number;
    width?: string;
    variant?: "block" | "text" | "stat";
    label?: string;
  }
  const { rows = 1, height = 16, width = "100%", variant = "text", label = "Loading" }: Props =
    $props();
  const items = $derived(Array.from({ length: rows }, (_, i) => i));
</script>

<div class="skeleton-group" role="status" aria-busy="true" aria-label={label}>
  {#each items as i (i)}
    <div class="sk sk-{variant}" style:height="{height}px" style:width={width}></div>
  {/each}
  <span class="sr-only">{label}…</span>
</div>

<style>
  .skeleton-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sk {
    border-radius: 8px;
    background: linear-gradient(90deg, var(--surface) 25%, var(--surface-2) 37%, var(--surface) 63%);
    background-size: 400% 100%;
    animation: sk-shimmer 1.4s ease infinite;
  }
  .sk-stat {
    border-radius: var(--radius);
  }
  @media (prefers-reduced-motion: reduce) {
    .sk {
      animation: none;
      background: var(--surface-2);
    }
  }
  @keyframes sk-shimmer {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }
</style>
